import React, { useState, useEffect } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    inquiry_type: "",
    message: "",
  });

  const [contactInfo, setContactInfo] = useState({
    email: "",
    phone: "",
    address: "",
  });

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const inputStyle = {
    width: "-webkit-fill-available",
    padding: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    marginTop: "5px",
  };

  const detailStyle = {
    fontSize: "18px",
    marginBottom: "15px",
  };

  // Fetch Contact Details from API
  useEffect(() => {
    fetch("https://online.funforay.com/admin/api/settings")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data) {
          setContactInfo({
            email: data.data.email,
            phone: data.data.phone,
            address: data.data.address,
          });
        }
      })
      .catch(() => console.log("Failed to load contact info"));
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(
        "https://online.funforay.com/admin/api/contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await res.json();

      if (res.ok) {
        setSuccess(true);

        // Hide popup after 3 sec
        setTimeout(() => setSuccess(false), 3000);

        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          inquiry_type: "",
          message: "",
        });
      } else {
        alert(data.message || "Something went wrong!");
      }
    } catch (error) {
      alert("Server error!");
    }

    setLoading(false);
  };

  return (
    <>
      {/* SUCCESS POPUP */}
      {success && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            background: "#28a745",
            color: "#fff",
            padding: "12px 20px",
            borderRadius: "6px",
            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
            zIndex: 9999,
          }}
        >
          ✔ Message Sent Successfully!
        </div>
      )}

      {/* ================= Banner Section ================= */}
      {/* <section className="contact-banner">
        <h1 style={{ fontSize: "48px", fontWeight: "700" }}>Contact Us</h1>
      </section> */}

      {/* ================= Contact Section ================= */}
      <section className="contact-section">
         <h1 className="gallery_title">Contact Us</h1>
        <div className="container">
          
          {/* ============ Left Column: Contact Form ============ */}
          <div className="contact-form">
            <h2 style={{ marginBottom: "20px", color: "#e2068c" }}>
              Send Us a Message
            </h2>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "15px" }}>
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>

              <div style={{ marginBottom: "15px" }}>
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>

              <div style={{ marginBottom: "15px" }}>
                <label>Phone</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Phone"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>

              <div style={{ marginBottom: "15px" }}>
                <label>Inquiry Type</label>
                <select
                  name="inquiry_type"
                  required
                  value={formData.inquiry_type}
                  onChange={handleChange}
                  style={inputStyle}
                >
                  <option value="">Select Option</option>
                  <option value="holiday">Holiday Package</option>
                  <option value="flights">Flights</option>
                  <option value="hotels">Hotels</option>
                  <option value="other">Others</option>
                </select>
              </div>

              <div style={{ marginBottom: "15px" }}>
                <label>Message</label>
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="5"
                  required
                  value={formData.message}
                  onChange={handleChange}
                  style={inputStyle}
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="btnsubmit"
              >
                {loading ? "Sending..." : "Submit"}
              </button>
            </form>
          </div>

          {/* ============ Right Column: Contact Details ============ */}
          <div className="contact-details">
            <h2 className="details_head">Contact Details</h2>
<div>
            <p>
              <img src="images/email.png" alt="Email" style={{ marginRight: "10px" }} /><strong>Email:</strong>{" "}
              <a href={`mailto:${contactInfo.email}`}>
                {contactInfo.email || "Loading..."}
              </a>
            </p>

          <p>
  <img
    src="images/old-typical-phone.png"
    alt="Phone"
    style={{ marginRight: "10px" }}
  />

  <strong>Phone:</strong>{" "}

  {(contactInfo.phone || "Loading...")
    .split("/")
    .map((phone, index) => {
      const cleanPhone = phone.trim();

      return (
        <span key={index}>
          <a href={`tel:${cleanPhone.replace(/\s+/g, "")}`}>
            {cleanPhone}
          </a>

          {index !==
            (contactInfo.phone || "")
              .split("/").length - 1 && " / "}
        </span>
      );
    })}
</p>

            <p>
              <img src="images/address.png" alt="Address" style={{ marginRight: "10px" }} /><strong>Address:</strong> <a href={contactInfo.address_link || "#"} target="_blank" rel="noopener noreferrer">{contactInfo.address || "Loading..."}</a>
            </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
